<template>
  <v-list-item
    :to="to"
    @click="onClick"
  >
    <v-list-item-avatar>
      <v-icon>
        {{ icon }}
      </v-icon>
    </v-list-item-avatar>
    <v-list-item-title>
      {{ text }}
    </v-list-item-title>
    <v-list-item-action>
      <v-icon>
        fal fa-arrow-right
      </v-icon>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'SquaredButton',
  props: {
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: null
    },
    to: {
      type: Object,
      default: undefined
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>
